export const SET_TABLE_DATA = 'SET_TABLE_DATA';
export const SET_DIALOG_CROWD_SHOPWINDOW = 'SET_DIALOG_CROWD_SHOPWINDOW';

// 页码区域
export const SET_Q_CROWD_PAGE_SIZE = 'SET_Q_CROWD_PAGE_SIZE';
export const SET_Q_CROWD_PAGE_COUNT = 'SET_Q_CROWD_PAGE_COUNT';
export const SET_Q_CROWD_PAGE_TOTAL = 'SET_Q_CROWD_PAGE_TOTAL';
